import * as THREE from 'three';

export interface CharacterAnimationRegistration {
	id: string;
	json: any;
	autoBlend: boolean;
	playbackSpeed: number;
}

export interface CharacterAnimationDefinition {
	id: string;
	autoBlend: boolean;
	autoBlendTriggered?: boolean;
	idle: boolean;
	json: any;
	clip: THREE.AnimationClip;
	reversedClip?: THREE.AnimationClip;
	action: THREE.AnimationAction;
	reversedAction?: THREE.AnimationAction;
	playbackSpeed: number;
}

export interface AnimationFadeInterface {
	id: string;
	actionSelector?: "action" | "reversedAction";
	from: number
	to: number;
	fadeTimeMS?: number;
	onComplete?: Function;
}

export interface AnimationActivationInterface {
	id: string;
	weight: number;
	fadeTimeMS?: number;
	loopTimes?: number;
}

export interface AnimationDeactivationInterface {
	id: string;
	fadeTimeMS?: number;
}

export interface AnimationProgressEvent {
	type: AnimationProgressEventType;
	animationAction?: THREE.AnimationAction;
}

export enum AnimationProgressEventType {
	started = "started",
	loop = "loop",
	approaching = "approaching", // When the animation playback time exceeds the reverseAnimationApproach time
	finished = "finished"
}